<template>
  <!-- 主容器 -->
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="80px">
      <!-- 学生姓名搜索 -->
      <el-form-item label="学生姓名" prop="name">
        <el-input v-model="queryParams.NAME" placeholder="请输入学生姓名" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <!-- 班级选择搜索 -->
      <el-form-item label="所属班级" prop="classId">
        <el-select v-model="queryParams.classId" placeholder="请选择班级" clearable size="small">
          <el-option v-for="classItem in classList" :key="classItem.id" :label="classItem.className"
            :value="classItem.id" />
        </el-select>
      </el-form-item>

      <!-- 身份证号搜索 -->
      <el-form-item label="身份证号" prop="card">
        <el-input v-model="queryParams.card" placeholder="请输入身份证号" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <!-- 搜索按钮 -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">
          搜索
        </el-button>
        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 操作按钮区域 -->
    <el-row :gutter="10" class="mb8">
      <!-- 新增按钮 -->
      <el-col :span="1.5">
        <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleAdd">
          新增
        </el-button>
      </el-col>

      <!-- 修改按钮 -->
      <el-col :span="1.5">
        <el-button type="success" plain icon="el-icon-edit" size="mini" :disabled="single"
          @click="handleUpdate">修改</el-button>
      </el-col>
      
      <!-- 删除按钮 -->
      <el-col :span="1.5">
        <el-button type="danger" plain icon="el-icon-delete" size="mini" :disabled="multiple"
          @click="handleDelete">删除</el-button>
      </el-col>
      
      <!-- 导出按钮 -->
      <el-col :span="1.5">
        <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col>
    </el-row>

    <!-- 数据表格 - 添加行点击事件 -->
    <el-table v-loading="loading" :data="studentList" @selection-change="handleSelectionChange" 
      @row-click="handleRowClick" class="table-container">
      <!-- 选择列 -->
      <el-table-column type="selection" width="55" align="center" />

      <!-- 学生ID列 -->
      <el-table-column label="学生ID" align="center" prop="id" width="80" />

      <!-- 学生姓名列 -->
      <el-table-column label="学生姓名" align="center" prop="name" />

      <!-- 所属班级列 -->
      <el-table-column label="所属班级" align="center" prop="className" />

      <!-- 身份证号列 -->
      <el-table-column label="身份证号" align="center" prop="card" width="180" />

      <!-- 出生日期列 -->
      <el-table-column label="出生日期" align="center" prop="birthDate" width="120" />

      <!-- 家庭住址列 -->
      <el-table-column label="家庭住址" align="center" prop="address" />

      <!-- 操作列 -->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="180">
        <template slot-scope="scope">
          <!-- 修改按钮 -->
          <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">
            修改
          </el-button>

          <!-- 删除按钮 -->
          <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination background class="pagination-container" v-show="total > 0" :current-page="queryParams.pageNum"
      :page-sizes="[5, 10, 20, 50]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

    <!-- 新增/编辑对话框 - 添加 close-on-click-modal 和 close-on-press-escape -->
    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body
      :close-on-click-modal="false" :close-on-press-escape="false" @close="handleDialogClose">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <!-- 用户信息部分 -->
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="form.userName" placeholder="请输入用户名"></el-input>
            </el-form-item>
            
            <el-form-item label="密码" prop="password">
              <el-input v-model="form.password" type="password" placeholder="请输入密码"></el-input>
            </el-form-item>
            
            <!-- 学生基本信息部分 -->
            <el-form-item label="学生姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入学生姓名" />
            </el-form-item>
            
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="form.sex">
                <el-radio label="0" value="0">男</el-radio>
                <el-radio label="1" value="1">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="出生日期" prop="birthDate">
              <el-date-picker clearable v-model="form.birthDate" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择出生日期" style="width: 100%">
              </el-date-picker>
            </el-form-item>
            
            <el-form-item label="身份证号" prop="card">
              <el-input v-model="form.card" placeholder="请输入身份证号" />
            </el-form-item>
            
            <el-form-item label="电话号码" prop="phonenumber">
              <el-input v-model="form.phonenumber" placeholder="请输入电话号码"
                @input="form.phonenumber = form.phonenumber.replace(/\D/g, '')" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="所属班级" prop="classId">
          <el-select v-model="form.classId" placeholder="请选择班级" style="width: 100%">
            <el-option v-for="classItem in classList" :key="classItem.id" :label="classItem.className"
              :value="classItem.id"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="家庭住址" prop="address">
          <el-input v-model="form.address" type="textarea" :rows="2" placeholder="请输入家庭住址" />
        </el-form-item>
      </el-form>

      <!-- 对话框底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listStudents, getStudents, delStudents, addStudents, updateStudents } from "@/api/OmdStudents/students";
import { listClasses } from "@/api/OmdClasses/classes";
import { addUser } from "@/api/system/user";
import { download } from "@/utils/request";

export default {
  name: "InformationMain",
  data() {
    return {
      // 加载状态
      loading: true,
      // 选中行的ID数组
      ids: [],
      // 是否单选（用于判断修改按钮状态）
      single: true,
      // 是否多选（用于判断删除按钮状态）
      multiple: true,
      // 是否显示搜索区域
      showSearch: true,
      // 总条数
      total: 0,
      // 学生列表数据
      studentList: [],
      // 班级选项数据
      classList: [],
      // 对话框标题
      title: "",
      // 是否显示对话框
      open: false,

      // 查询参数
      queryParams: {
        pageNum: 1,       // 当前页码
        pageSize: 10,     // 每页条数
        NAME: null,       // 学生姓名
        classId: null,    // 班级ID
        card: null,       // 身份证号
      },

      // 表单数据
      form: {
        id: null,         // 学生ID
        userName: null,   // 用户名
        password: null,   // 密码
        name: null,       // 学生姓名
        sex: 0,          // 性别
        birthDate: null,  // 出生日期
        card: null,       // 身份证号
        classId: null,    // 班级ID
        phonenumber: null, // 电话号码
        address: null     // 家庭住址
      },

      // 表单验证规则
      rules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        name: [
          { required: true, message: "请输入学生姓名", trigger: "blur" }
        ],
        sex: [
          { required: true, message: "请选择性别", trigger: "change" }
        ],
        birthDate: [
          { required: true, message: "请选择出生日期", trigger: "change" }
        ],
        card: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }
        ],
        classId: [
          { required: true, message: "请选择班级", trigger: "change" }
        ],
        phonenumber: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { pattern: /^\d{11}$/, message: "请输入正确的11位电话号码", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入家庭住址", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    // 组件创建时获取数据
    this.getList();
    this.getClassList();
  },
  methods: {
    /**
     * 处理行点击事件
     * @param {Object} row 行数据
     * @param {Object} column 列信息
     * @param {Event} event 事件对象
     */
    handleRowClick(row, column, event) {
      // 如果点击的是操作列，则不触发详情查看
      if (column.property || column.type === 'selection') {
        this.handleUpdate(row);
        console.log(event);
      }
    },
    
    /**
     * 处理对话框关闭事件
     */
    handleDialogClose() {
      this.reset();
    },

    /**
     * 获取学生列表
     * @return {void}
     */
    getList() {
      this.loading = true;
      listStudents(this.queryParams)
        .then(response => {
          this.studentList = response.rows;
          this.total = response.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 获取班级列表
     * @return {void}
     */
    getClassList() {
      listClasses()
        .then(response => {
          this.classList = response.rows;
        })
        .catch(error => {
          console.error("获取班级列表失败:", error);
        });
    },

    /**
     * 每页条数变化事件
     * @param {number} val 新的每页条数
     * @return {void}
     */
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },

    /**
     * 当前页变化事件
     * @param {number} val 新的页码
     * @return {void}
     */
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },

    /**
     * 取消操作（关闭对话框）
     * @return {void}
     */
    cancel() {
      this.open = false;
      this.reset();
    },

    /**
     * 重置表单
     * @return {void}
     */
    reset() {
      this.form = {
        id: null,
        userName: null,
        password: null,
        name: null,
        sex: 0,
        birthDate: null,
        card: null,
        classId: null,
        phonenumber: null,
        address: null
      };
      // 重置表单验证状态
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },

    /**
     * 搜索操作
     * @return {void}
     */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    /**
     * 重置搜索表单
     * @return {void}
     */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        NAME: null,
        classId: null,
        card: null,
      };
      this.handleQuery();
    },

    /**
     * 表格选择项变化事件
     * @param {Array} selection 选中的行数据
     * @return {void}
     */
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },

    /**
     * 新增操作
     * @return {void}
     */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加学生";
    },

    /**
     * 修改操作
     * @param {Object} row 行数据
     * @return {void}
     */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids[0];
      getStudents(id)
        .then(response => {
          this.form = response.data;
          console.log(this.form);
          console.log("鲁彦君");
          this.open = true;
          this.title = "修改学生";
        })
        .catch(error => {
          console.error("获取学生详情失败:", error);
        });
    },

    /**
     * 提交表单
     * @return {void}
     */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id) {
            // 修改学生信息
            updateStudents(this.form)
              .then(response => {
                this.$modal.msgSuccess("修改成功");
                this.open = false;
                this.getList();
                console.log(response);
              })
              .catch(error => {
                console.error("修改失败:", error);
              });
          } else {
            // 新增学生信息（先创建用户，再创建学生）
            addUser({
              userName: this.form.userName,
              password: this.form.password,
              sex: this.form.sex,
              remark: "学生",
              phonenumber: this.form.phonenumber,
              deptId: 101, // 代表山东欧曼第
              nickName: this.form.NAME,
            })
              .then(userRes => {
                if (userRes.code === 200) {
                  // 创建学生
                  return addStudents({
                    name: this.form.NAME,
                    birthDate: this.form.birthDate,
                    card: this.form.card,
                    address: this.form.address,
                    classId: this.form.classId,
                    userId: userRes.data.userId
                  });
                } else {
                  throw new Error(userRes.msg || "创建用户失败");
                }
              })
              .then(studentRes => {
                if (studentRes.code === 200) {
                  this.$modal.msgSuccess("新增成功");
                  this.open = false;
                  this.getList();
                } else {
                  throw new Error(studentRes.msg || "创建学生失败");
                }
              })
              .catch(error => {
                this.$modal.msgError(error.message);
                console.error("操作失败:", error);
              });
          }
        }
      });
    },

    /**
     * 删除操作
     * @param {Object|Number} row 行数据或ID
     * @return {void}
     */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$confirm(`是否确认删除编号为"${ids}"的学生？`, '警告', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'confirm-danger-button',
        cancelButtonClass: 'cancel-button'
      })
        .then(() => delStudents(ids))
        .then(() => {
          this.getList();
          this.$message.success('删除成功');
        })
        .catch(() => { });
    },
    
    /**
     * 导出按钮操作
     * @return {void}
     */
    handleExport() {
      download('/OmdStudents/students/export', {
        ...this.queryParams
      }, `学生表_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped>
/* 主容器样式 */
.app-container {
  padding: 20px;
}

/* 表格操作按钮紧凑样式 */
.small-padding .el-button {
  padding: 5px;
  margin-left: 0;
}

/* 表格头部样式 */
::v-deep .el-table__header-wrapper .el-table__header th {
  background-color: #f4f4f4 !important;
  color: #000 !important;
}

/* 分页器样式 */
::v-deep .el-pager li.active {
  background-color: var(--primary-color) !important;
  color: white !important;
  border-color: var(--primary-color) !important;
  font-weight: bold;
  cursor: pointer;
}

/* 分页器悬停样式 */
::v-deep .el-pager li.active:hover {
  background-color: #d6336c !important;
  color: white !important;
  background-color: #d6336c !important;
  font-weight: bold;
  cursor: pointer;
}
/*按钮的样式 主要按钮 的样式*/

::v-deep .el-button--primary {
  color: #fff;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

/*鼠标获得焦点的样式*/
::v-deep .el-button--primary:hover {
  background-color: #d6336c !important;
  ;
}

/* 在全局样式文件中添加 */
::v-deep .el-button:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 如果按钮是 plain 样式 */
::v-deep.el-button--plain:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 表格中的文字 */
/* ::v-deep .el-button--text  {
  color: var(--primary-color);
}   */


::v-deep .el-button--primary:focus,
.el-button--primary:hover {
  background-color: var(--primary-color);
  border: none;
  color: #fff;
}

/* 文本框 初始边框
::v-deep .el-input__inner,.el-textarea__inner {
  border:1px solid var(--primary-color);
} */
/* 文本框鼠标获得焦点边框 */
::v-deep .el-input__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 如果是 textarea */
::v-deep .el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
}

</style>